<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre sigil_not_in_toc" id="calibre_pb_2"><a class="calibre1" id="Image_002"><img alt="image002" class="calibre7" id="id-3622366551240816968" src="Images/img0001.jpg"/></a></h2>
<h4 class="calibre8 sigil_not_in_toc" id="pgepubid00000">“Now tell me what is your name?”</h4>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?1aa67ea2